import { injectable, inject } from "inversify";

import { HttpService } from "src/core/services/http.service";

export interface ITransactionInfo {
	sessionId: string;
}

@injectable()
export default class CheckoutDataService {

	@inject(HttpService)
	httpService: HttpService;

	private baseUrl = 'api/v1/gateway';
	private paymentUrl = 'api/v1/payments';

	public async getServiceInformation(): Promise<IServiceInfo[]> {
		try {
			const result = await this.httpService.get(`${this.baseUrl}/name`);
			return result.data;
		} catch (err) {
			throw err;
		};
	}

	public async openSession<T>(name: string): Promise<T> {
		try {
			const result = await this.httpService.get(`${this.paymentUrl}/create/${name}`);
			return result.data;
		} catch (err) {
			throw err;
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/payment-gateway/checkout-service.ts